(function($) {
    let ABSL = {
        ui : {
            w: $(window),
            b: $('body'),
            h: $('.pageHeader'),
            sliders: null,
            contentModal: $('#contentModal')
        },

        templates: {
            partnerDetails: null,
            summaryPopup: null
        },

        toggleBurger: function() {
            let burger = $('.pageHeader .ui-burger'),
                body = $('body');

            burger.on('click', () => body.toggleClass('is-navexpanded'));
        },

        scrollabit: function() {
            let self = this;

            $('.js-scrolldown').on('click', function(e) {
                let hh = self.ui.h.height();
                let tgt = $(this).parent().next();
                e.preventDefault();

                $('body, html').stop().animate({
                    scrollTop: tgt.offset().top - hh
                });
            });
        },

        moreless: function () {
            $('.js-more').on('click', function(e) {
                let prnt = $(this).parents('.js-more-container');

                prnt.addClass('is-expanded');
                prnt.find('.js-more-tgt').stop().slideDown();
            });

            $('.js-less').on('click', function(e) {
                let prnt = $(this).parents('.js-more-container');

                prnt.removeClass('is-expanded');
                prnt.find('.js-more-tgt').stop().slideUp();
            });
        },

        morenews: function() {
            let offset = 10;
            const postsPerPage = 10;

            function doIt(e, btn) {
                e.preventDefault();
                let container = btn.closest('.js-morenews-container');
                let ajaxcontainer = container.find('.ajaxcontainer');

                container.addClass('loading');
                btn.hide();

                $.ajax({
                    url: window.ajaxurl,
                    data: {
                        action: 'morenews',
                        offset: offset
                    },
                    dataType: 'json',
                    success: function(data) {
                        container.removeClass('loading');
                        ajaxcontainer.append(data.posts);
                        offset = offset + postsPerPage;

                        if (data.hasmore) {
                            btn.show();
                        }
                    },
                    error: function(data) {
                        console.log('error');
                        console.log(data);

                        container.removeClass('loading');
                        btn.show();
                    }
                });
            }

            $('.js-morenews').on('click', function(e) {
                doIt(e, $(this));
            });
        },
		
		slider: function() {
            let sliders = $('.simpleSlider');
            if (! sliders.length) return;

            sliders.each(function(index, slider) {
                tns({
                    container: '#' + slider.id,
                    items: 1,
                    controls: false,
                    navPosition: 'bottom'
                });
            });
        },

        partners: function() {
            if (! $('.js-partner-modal').length) {
                return;
            }
            this.templates.partnerDetails = _.template($('#templatePartnerDetails').html());

            this.ui.contentModal.on('hidden.bs.modal', () => {
                this.ui.contentModal.find('.modal-body').empty();
            });

            $('.js-partner-modal').on('click', e => {
                let el = $(e.delegateTarget);
                if (el.hasClass('loading')) {
                    return false;
                }
                let id = el.data('partnerid');
                if (! id) {
                    return false;
                }

                this.loadPartner(el, id);
            });
        },

        loadPartner: function(el, id) {
            let self = this;
            el.addClass('loading');

            $.ajax({
                url: window.ajaxurl,
                type: 'POST',
                data: {
                    action: 'partnerdetails',
                    id: id
                },
                dataType: 'json',
                success: function(response) {
                    let content = self.templates.partnerDetails(response.data);
                    self.ui.contentModal.find('.modal-body').html(content);
                    self.ui.contentModal.modal('show');
                },
                error: function(data) {
                    console.log('error');
                    console.log(data);
                },
                complete: function() {
                    el.removeClass('loading');
                }
            });
        },

        summaryPopups: function() {
            var $popups = $('[data-action="summaryPopup"]');
            if (! $popups.length) {
                return;
            }
            this.templates.summaryPopup = _.template($('#templateSummaryPopup').html());

            this.ui.contentModal.on('hidden.bs.modal', () => {
                this.ui.contentModal.find('.modal-body').empty();
            });

            $popups.on('click', e => {
                let el = $(e.delegateTarget);

                this.loadSummary(el.parent('.js-summaryPopup'));
            });
        },

        loadSummary: function(el) {
            let self = this;
            
            let contentData = {
                title: el.find('.js-summaryPopup-title').text(),
                description: el.find('.js-summaryPopup-description').text(),
                content: el.find('.js-summaryPopup-content').html()
            };
            let content = self.templates.summaryPopup(contentData);

            self.ui.contentModal.find('.modal-body').html(content);
            self.ui.contentModal.modal('show');
        },

        init: function() {
            this.toggleBurger();
            this.scrollabit();
            this.moreless();
            this.morenews();
			this.slider();
            this.partners();
            this.summaryPopups();
        }
    }

    $(document).ready(() => {
        ABSL.init();
    });

})(jQuery)